export default __webpack_public_path__ + "static/media/add.ec088ba2.svg";